export enum PaymentMethod {
  ONLINE_BANKING = 'Transfer',
  WIRE_TRANSFER = 'QR',
  BNPL = 'BNPL',
  CREDIT_CARD = 'Credit Card',
  QRPH_P2P = 'QRPH P2P',
  QRPH_P2M = 'QRPH P2M'
}
